import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}stripe/createOrUpdateStripeSellerAccount`;

export interface CreateOrUpdateStripeSellerAccountArgs {
  sellerId: string;
  token: string;
}

export default async function createOrUpdateStripeSellerAccount(
  payload: CreateOrUpdateStripeSellerAccountArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    return await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        sellerId: payload.sellerId,
        token: payload.token,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
